import { Checkbox, Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../../styles/savers/custom.css';
import { getTrailerStatusColor } from '@/utils/savers/utils';
import { exportDataToExcel } from '@/utilz';
import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';
import { setTrailerId, setTrailerRequestId } from '../../../redux/Savers/SaversActions';
import { setLocationRequestId } from '../../../redux/Savers/SaversActions';
import { getTrailerRequestByTrailerIDEffect, getTrailersListEffect } from '../../../redux/Savers/SaversEffects';
import { setAppLoader } from '../../../redux/common/CommonActions';
import SecondaryLabel from '../../components/Labels/SecondaryLabel';
import AlertModal from '../../components/Modals/AlertModal';
import ScrollPagination from '../../components/Paginations/ScrollPagination';
import ContentSpinner from '../../components/Spinners/ContentSpinner';
import TrailerSearch from '../../screens/Savers/TrailerSearch';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, excludedStatuses } from './trailer-request.constants';

export const dateFormatter = (cell) => {
  const newDate = moment(cell).format('MMM D YYYY');
  return <span>{newDate}</span>;
};

const TRAILER_ERROR_MESSAGE =
  'Trailer request has not been created for this trailer. Please create trailer request to continue.';

const bgColors = {
  Planned: '#825B5B',
  Unassigned: '#00B1E1',
  Unconfirmed: '#825B5B',
  Broken: '#E9573F',
  Assigned: '#F6BB42',
};

const getStyle = (cell, bgColors) => {
  if (!bgColors || cell === '' || cell === null) return {};

  if (cell === 'Planned') {
    return {
      backgroundColor: bgColors.Planned,
      color: '#FFFFFF',
    };
  }
  if (cell === 'Broken') {
    return {
      backgroundColor: bgColors.Broken,
      color: '#FFFFFF',
    };
  }
  if (cell === 'Unconfirmed') {
    return {
      backgroundColor: bgColors.Unconfirmed,
      color: '#FFFFFF',
    };
  }
  if (cell === 'Assigned') {
    return {
      backgroundColor: bgColors.Assigned,
      color: '#FFFFFF',
    };
  }
  if (cell === 'Unassigned') {
    return {
      backgroundColor: bgColors.Unassigned,
      color: '#FFFFFF',
    };
  }

  return {
    backgroundColor: '#ffff',
    color: 'black',
  };
};

export default function TrailerDatabase({ isModal, handleTrailerData, status }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const branchKey = location?.state?.branchKey || useSelector((state) => state.savers.locID.data);
  const { selectedCompany } = useSelector((state) => state.auth);
  const userRole = useSelector((state) => state.savers.loggedInUser.data);
  const [loading, setLoading] = useState(false);
  const [errMessage, setErrMessage] = useState('');
  const [trailerOptions, setTrailerOptions] = useState([]);
  const [tempTrailerOptions, setTempTrailerOptions] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [selectedTrailerId, setSelectedTrailerId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [trailerParams, setTrailerParams] = useState('');

  useEffect(() => {
    if (!isModal) {
      getTrailerList(branchKey);
    } else {
      const Code = status === 'Loaded' ? 'LOD' : 'EMT';
      getTrailerList('', '', Code, '');
    }
  }, [selectedCompany]);

  const onAlertConfirm = () => {
    setAlertOpen(false);
  };

  const handleGeneralSearch = (searchTerm) => {
    const filteredOptions = trailerOptions.filter((option) =>
      Object.values(option).some(
        (value) => typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
    setTempTrailerOptions(filteredOptions);
  };

  const getTrailerList = async (branchKey, trailerId, statuscode, locationType, reset) => {
    try {
      setLoading(true);
      const params = {};
      if (branchKey) {
        params.branchKey = branchKey;
      }
      if (trailerId) {
        params.trailerId = trailerId;
      }
      if (statuscode) {
        params.status = statuscode;
      }
      if (locationType) {
        params.locationType = locationType;
      }
      if (isModal) {
        params.regionDesc = 'yard';
      }
      if (reset) {
        setCurrentPage(1);
      }
      setTrailerParams(params);
      params.PageSize = DEFAULT_PAGE_SIZE;
      params.PageNumber = reset ? DEFAULT_PAGE_NUMBER : currentPage;
      const { data } = await getTrailersListEffect(params);

      setTrailerOptions(data);
      setTempTrailerOptions(data);
      if (data.length === 0) {
        setErrMessage('Data not found.');
      } else {
        setErrMessage('');
      }
      dispatch(setLocationRequestId(''));
      setLoading(false);
    } catch (error) {
      console.error(error);
      setTrailerOptions([]);
      setTempTrailerOptions([]);
      setLoading(false);
    }
  };

  const columnFormatter = () => {
    return <ArrowRightOutlined />;
  };

  const rollDoorCheckbox = (val) => {
    return <Checkbox checked={val} disabled />;
  };

  const handleSelectTrailer = (trailerId, row) => {
    setSelectedTrailerId(trailerId);
    handleTrailerData({ trailerId: trailerId, trailerData: row });
  };

  const SelectTrailer = (trailerId, row) => {
    return (
      <Checkbox
        value={trailerId}
        checked={selectedTrailerId === trailerId}
        onChange={() => handleSelectTrailer(trailerId, row)}
      />
    );
  };

  const columns = [
    {
      dataField: 'trailerID',
      text: 'ID',
      hidden: true,
    },
    {
      dataField: 'trailerID',
      text: 'Select',
      headerStyle: { textAlign: 'center' },
      align: 'center',
      formatter: (val, row) => SelectTrailer(val, row),
      sort: true,
      hidden: !isModal,
    },
    {
      dataField: 'trailerNumber',
      text: 'Trailer #',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'unitSize',
      text: 'Trailer Size',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'right',
    },
    {
      dataField: 'branchDesc',
      text: 'Location Name',
      headerStyle: { width: '250px', textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'branchCustRef',
      text: 'Location ID',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'right',
    },
    {
      dataField: 'vendorId',
      text: 'Vendor Id',
      headerStyle: { textAlign: 'center' },
      formatter: (col, row) => (row.statusDesc === 'Empty' ? '' : <div>{col}</div>),
      align: 'right',
    },
    {
      dataField: 'locationType',
      text: 'Supply Zone Number',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'right',
    },
    {
      dataField: 'rollDoor',
      text: 'Roll Door',
      headerStyle: { textAlign: 'center' },
      align: 'center',
      formatter: (val) => rollDoorCheckbox(val),
      sort: true,
    },
    {
      dataField: 'loadedDate',
      text: 'Load Date',
      headerStyle: { width: '150px', textAlign: 'center' },
      formatter: (col, row) => (row.statusDesc === 'Empty' ? '' : dateFormatter(col, row)),
      align: 'left',
    },
    {
      dataField: 'statusDesc',
      text: 'Status',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
      hidden: true,
    },
    {
      dataField: 'yardName',
      text: 'Yard',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
      hidden: true,
    },
    {
      dataField: 'storageDate',
      text: 'In Storage Date',
      headerStyle: { textAlign: 'center' },
      sort: true,
      formatter: dateFormatter,
      align: 'left',
    },
    {
      dataField: 'soft',
      text: 'Soft Weight',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'softOks',
      text: 'Soft Oks',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'misc',
      text: 'Misc Weight',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'miscOKs',
      text: 'Misc OKs',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'book',
      text: 'Book Weight',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'bookOks',
      text: 'Book Oks',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'furn',
      text: 'Furn',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'oli',
      text: 'Oli',
      headerStyle: { textAlign: 'center' },
      sort: true,
      align: 'left',
    },
    {
      dataField: 'trailerStatus',
      text: 'CT Trailer Status',
      headerStyle: { textAlign: 'center' },
      style: (cell) => {
        if (cell === '' || cell === null) {
          return {};
        }
        if (cell === 'Planned') {
          return {
            backgroundColor: bgColors.Planned,
            color: '#FFFFFF',
          };
        }
        if (cell === 'Broken') {
          return {
            backgroundColor: bgColors.Broken,
            color: '#FFFFFF',
          };
        }
        if (cell === 'Unconfirmed') {
          return {
            backgroundColor: bgColors.Unconfirmed,
            color: '#FFFFFF',
          };
        }
        if (cell === 'Assigned') {
          return {
            backgroundColor: bgColors.Assigned,
            color: '#FFFFFF',
          };
        }
        if (cell === 'Unassigned') {
          return {
            backgroundColor: bgColors.Unassigned,
            color: '#FFFFFF',
          };
        }

        return {
          backgroundColor: '#c8e6c9',
          color: '#FFFFFF',
        };
      },
      align: 'left',
      sort: true,
      hidden: true,
    },
    {
      dataField: 'unitRentalCompany',
      text: 'Rental Company',
      headerStyle: { textAlign: 'center' },
      align: 'left',
      formatter: (cell) => (cell === 'NULL' ? '' : cell),
    },
    {
      dataField: 'isOutOfService',
      text: 'Not Used',
      headerStyle: { textAlign: 'center' },
      align: 'center',
      formatter: (val) => rollDoorCheckbox(val),
      sort: true,
      hidden: isModal,
    },
    {
      dataField: 'notInUseReason',
      text: 'Comment',
      headerStyle: { textAlign: 'center' },
      align: 'center',
      sort: true,
      hidden: isModal,
    },
    {
      dataField: 'request',
      text: 'Go to Trailer Requests',
      headerStyle: { textAlign: 'center' },

      align: 'center',
      formatter: columnFormatter,
      events: {
        onClick: (_e, _column, _columnIndex, row) => {
          LoadTrailerRequestData(row.trailerID);
        },
      },
      hidden: isModal,
    },
  ];

  const LoadTrailerRequestData = async (trailerID) => {
    dispatch(setAppLoader(true));
    try {
      const { data } = await getTrailerRequestByTrailerIDEffect(trailerID);
      if (data?.length > 0) {
        if (data[0].trailerRequestData?.length > 0) {
          setAlertOpen(false);
          dispatch(setTrailerId(trailerID));
          dispatch(setTrailerRequestId(0));
          navigate('/Trailer-Review');
        } else {
          setAlertOpen(true);
        }
      } else {
        setAlertOpen(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const handleExport = () => {
    const filteredColumns = columns.filter(
      (column) => column.dataField !== 'request' && column.dataField !== 'trailerID',
    );

    exportDataToExcel(trailerOptions, 'Trailer_Data', filteredColumns);
  };

  const handleNextPage = async () => {
    try {
      const params = { ...trailerParams, PageNumber: currentPage + DEFAULT_PAGE_NUMBER, PageSize: DEFAULT_PAGE_SIZE };
      const { data } = await getTrailersListEffect(params);

      setTrailerOptions((prev) => [...prev, ...data]);
      setTempTrailerOptions((prev) => [...prev, ...data]);

      setCurrentPage(currentPage + 1);

      if (data.length === 0) {
        setErrMessage('No more data available.');
      } else {
        setErrMessage('');
      }

      dispatch(setLocationRequestId(''));
    } catch (error) {
      setErrMessage(`Error loading data:${error.message}`);
    }
  };

  return (
    <>
      {!isModal && (
        <Row gutter={20}>
          <Col sm={24}>
            <span className="pull-right color-1" style={{ position: 'fixed', right: '32px', marginTop: '-26px' }}>
              {' '}
              <strong> {userRole} </strong> Logged In{' '}
            </span>
          </Col>
        </Row>
      )}
      <div className="paper-container h-100 w-100">
        <div className="py-5 px-10">
          <AlertModal
            title="Alert"
            open={alertOpen}
            description={TRAILER_ERROR_MESSAGE}
            onOk={onAlertConfirm}
            onClose={onAlertConfirm}
          />
          <TrailerSearch
            branchKey={branchKey}
            isModal={isModal}
            onSearchClick={getTrailerList}
            onGeneralSearch={handleGeneralSearch}
            status={status}
          />
          {loading ? (
            <div style={{ marginTop: '15%' }}>
              <ContentSpinner size="large" />
            </div>
          ) : (
            <Row gutter={15}>
              <Col sm={24}>
                <div className="savers">
                  <div className="mx-1 mb-4  d-flex w-full justify-content-between align-items-end">
                    <div className="mx-1 fw-800">
                      {location.state?.branchDesc &&
                        location.state?.locationType &&
                        `${location.state.branchDesc} - ${location.state.locationType}`}
                    </div>
                    {!isModal && (
                      <button type="button" className="btn btn-dipblue" onClick={handleExport}>
                        Export to Excel
                      </button>
                    )}
                  </div>
                  <ScrollPagination
                    className="background-white br-4 w-100 h-100 scrollable-table-container horizontal vertical"
                    scrollOffset={50}
                    loadMore={handleNextPage}
                  >
                    <table className="w-100 background-white br-4">
                      <thead className=" ">
                        <tr>
                          {columns.map(
                            ({ text, hidden }) =>
                              !hidden && (
                                <th key={text} className="background-header text-white fixed fixed-top fixed-left">
                                  {text}
                                </th>
                              ),
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {tempTrailerOptions.length === 0 ? (
                          <tr>
                            <td colSpan={columns.length} style={{ textAlign: 'center', color: 'red' }}>
                              {errMessage}
                            </td>
                          </tr>
                        ) : (
                          (isModal
                            ? tempTrailerOptions.filter(
                                (row) => !row.isOutOfService && !excludedStatuses.includes(row.trailerStatusID),
                              )
                            : tempTrailerOptions
                          ).map((row) => (
                            <tr key={row.trailerID}>
                              <GenerateColumnValues
                                row={row}
                                columns={columns}
                                bgColors={bgColors}
                                getStyle={getStyle}
                                isModal={isModal}
                              />
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </ScrollPagination>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </>
  );
}

const GenerateColumnValues = ({ row, columns, bgColors, getStyle, isModal }) => {
  const rowStyle = {
    backgroundColor: isModal ? 'white' : !row.isOutOfService ? getTrailerStatusColor(row.trailerStatusID) : '#ff9999',
  };

  return (
    <>
      {columns.map(
        ({ dataField, formatter, hidden, align, events }) =>
          !hidden && (
            <td
              key={dataField}
              className={`text-${align || 'left'}`}
              style={{ ...getStyle(row[dataField], bgColors), ...rowStyle }}
            >
              <SecondaryLabel className="f-15 fw-600 text-black">
                {events?.onClick ? (
                  <Link to="#" onClick={(e) => events.onClick(e, null, null, row, null)}>
                    {formatter ? formatter(row[dataField], row) : row[dataField]}
                  </Link>
                ) : formatter ? (
                  formatter(row[dataField], row)
                ) : (
                  row[dataField]
                )}
              </SecondaryLabel>
            </td>
          ),
      )}
    </>
  );
};
